import { APP_NAME } from "@/config/env";
import { useTranslation } from "react-i18next";
import { cn } from "@/shared/utils/cn";

import { VeltroLogo } from "./VeltroLogo";

type VeltroBrandLockupProps = {
  className?: string;
  subtitle?: string | null;
  framed?: boolean;
  size?: "sm" | "md" | "lg";
};

const sizeClasses = {
  sm: {
    wrapper: "gap-2",
    frame: "size-8 rounded-lg",
    logo: "h-5 w-auto",
    title: "text-sm font-semibold",
    subtitle: "text-xs",
  },
  md: {
    wrapper: "gap-3",
    frame: "size-11 rounded-2xl",
    logo: "h-6 w-auto",
    title: "text-base font-semibold tracking-[-0.02em]",
    subtitle: "text-sm",
  },
  lg: {
    wrapper: "gap-4",
    frame: "size-14 rounded-2xl",
    logo: "h-8 w-auto",
    title: "text-xl font-semibold tracking-[-0.02em]",
    subtitle: "text-sm font-medium",
  },
} as const;

export function VeltroBrandLockup({
  className,
  subtitle,
  framed = true,
  size = "md",
}: VeltroBrandLockupProps) {
  const { t } = useTranslation("common");
  const styles = sizeClasses[size];
  const resolvedSubtitle = subtitle === undefined ? t("app.tagline") : subtitle;

  return (
    <div className={cn("flex items-center", styles.wrapper, className)}>
      <div
        className={cn(
          "flex items-center justify-center",
          framed &&
            "border border-white/60 bg-white/80 shadow-lg shadow-blue-950/10 backdrop-blur-sm",
          styles.frame,
        )}
      >
        <VeltroLogo className={styles.logo} />
      </div>
      <div className="min-w-0 group-data-[collapsible=icon]:hidden">
        <p className={cn("truncate text-slate-950", styles.title)}>{APP_NAME}</p>
        {resolvedSubtitle ? (
          <p className={cn("truncate text-slate-600", styles.subtitle)}>{resolvedSubtitle}</p>
        ) : null}
      </div>
    </div>
  );
}
